import { render, staticRenderFns } from "./MdPatientRegistrationsHistory.vue?vue&type=template&id=04213c59&"
import script from "./MdPatientRegistrationsHistory.vue?vue&type=script&lang=js&"
export * from "./MdPatientRegistrationsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports